import RoomVariantDetail from "../components/organisms/proposal/RoomVariantDetail";

const ProposalVariant = () => {
  return (
    <RoomVariantDetail/>
  )
}

export default ProposalVariant;